module.exports = __webpack_public_path__ + "static/media/Frame.85fedf87.svg";